const informationMixin = {
    data() {
        return {
            age: 26,
            email: 'ragiedoromal06@gmail.com',
            mobileNumber: '(+63) 976-521-4782',

            socials: [
                {
                    text: 'GitHub',
                    icon: 'mdi-github',
                    link: 'https://github.com/appledrft2?tab=repositories',
                },
                {
                    text: 'LinkedIn',
                    icon: 'mdi-linkedin',
                    link: 'https://www.linkedin.com/in/ragie-doromal-106a1015a/',
                },
            ],

            skills: [
                {
                    text: 'HTML',
                    icon: 'mdi-language-html5',
                },
                {
                    text: 'CSS',
                    icon: 'mdi-language-css3',
                },
                {
                    text: 'JavaScript',
                    icon: 'mdi-language-javascript',
                },
                {
                    text: 'PHP',
                    icon: 'mdi-language-php',
                },
                {
                    text: 'SQL',
                    icon: 'mdi-database-search',
                },
                {
                    text: 'Git',
                    icon: 'mdi-git',
                },
                {
                    text: 'Vue',
                    icon: 'mdi-vuejs',
                },
                {
                    text: 'Laravel',
                    icon: 'mdi-laravel',
                },
                {
                    text: 'Adobe Photoshop',
                    icon: 'mdi-palette',
                },
                {
                    text: 'Adobe Illustrator',
                    icon: 'mdi-palette',
                },
            ],

            workExperiences: [
                {
                    company: 'Poxel Graphics and Apparel',
                    span: 'December 2023 - Present',
                    role: 'Graphic Artist',
                    type: 'Full-time',
                    url: 'https://www.facebook.com/Poxelgraphicsandapparel',
                    gigs: [],
                    details: [
                        "Create precise size specifications for each garment, ensuring consistency and adherence to design requirements.",
                        "Produce detailed job orders to guide the printing, press, and sewing processes, tailored to each apparel piece.",
                        "Collaborate closely with printing, press, and sewing teams to align on job specifications and timelines.",
                        "Verify that all sizes and job order details meet company quality and brand standards.",
                        "Maintain organized records of all job orders and size specifications for easy access and future reference."
                    ],
                },
                {
                    company: 'Coders Tribe IT Solutions',
                    span: 'June 2023 - October 2023',
                    role: 'Program Facilitator',
                    type: 'Part-time',
                    url: 'https://www.coderstribe.net/',
                    gigs: [
                    ],
                    details: [
                        "Participated in planning and preparing lessons for the training program.",
                        "Reported student progress evaluations to my direct supervisor.",
                        "Facilitated and assisted students with their lessons throughout the training program.",
                        "Evaluated and assessed student progress within the training program.",
                        "Provided feedback and guidance to help students achieve their learning objectives.",

                    ],
                },

                {
                    company: 'Telcom Live Content Inc.',
                    span: 'Dec 2020 - Oct 2022',
                    role: 'Software Engineer',
                    type: 'Full-time',
                    url: 'https://mobilemoney.ph/',
                    gigs: [],
                    details: [
                        "Developed multiple web applications for the company as a front-end web developer",
                        "Used technologies including HTML, CSS, JavaScript, and frameworks such as Vue.js and Nuxt.js.",
                        "Collaborated with team members to resolve issues, align on requirements, and improve project development.",
                        "Participated in daily stand-up meetings to discuss progress, challenges, and coordinate with the team.",
                        "Deployed web applications to staging and production environments using Docker."
                    ],
                },
            ],

            educationExperiences: [
                {
                    level: 'College',
                    school: 'Northern Negros State College of Science and Technology',
                    course: 'BS Information Technology',
                    span: '2021',
                },
            ],

            certificationExperiences: [
                {
                    name: 'CODERS GUILD: SOFTWARE DEVELOPMENT TRAINING PROGRAM ',
                },
                {
                    name: 'PHILNITS LEVEL I: INFORMATION TECHNOLOGY PASSPORT (IP09-0020)',
                },
            ],

            projects: [
                {
                    name: 'NOLITC - Enrolment Management System',
                    description:
                        "An internal system used by the Negros Occidental Language & Information Technology Center (NOLITC) to efficiently manage and monitor students' enrollment process for the training program.",
                    technologies: 'PHP/Laravel, MySQL',
                    type: 'Work Project',
                    role: 'Lead Web Developer',
                    url: '',
                    previews: [],
                },
                {
                    name: 'DTI - Client Profile Monitoring System',
                    description:
                        "A monitoring system used by the Department of Trade and Industry (DTI) to track and collect data on micro to large business enterprises in the Philippines.",
                    technologies: 'NodeJS/Express, JS/Vue JS, MySQL',
                    type: 'Work Project',
                    role: 'Front End Web Developer',
                    url: '',
                    previews: [],
                },
                {
                    name: 'DTI - Product Certification Information Management System',
                    description:
                        "A product certification management system used by the Department of Trade and Industry (DTI) to efficiently manage and oversee the certification process for products, ensuring they meet the required standards for sale in the Philippine market.",
                    technologies: 'PHP/CodeIgniter, JS/Javascript, MySQL',
                    type: 'Work Project',
                    role: 'Front End Web Developer',
                    url: '',
                    previews: [],
                },

            ],
        };
    },
};

export default informationMixin;
